import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { Form as EditForm } from './edit_form'
import { EditAccommodationRoomTypeQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'

interface Props extends EditProps {
  accommodationId: string
}

export const EditDialog = ({ accommodationId, id, open, setOpen }: Props) => {
  const { data, loading } = useQuery<EditAccommodationRoomTypeQuery>(Query, {
    variables: { accommodationId, accommodationRoomTypeId: id }
  })

  return (
    <>
      <Dialog open={open} size="3xl" onClose={setOpen}>
        <DialogTitle>
          <div>
            { loading || !data ? <Loading /> : data.accommodations.nodes[0].accommodationRoomTypes.nodes[0].name }
          </div>
        </DialogTitle>
        <DialogBody>
          <EditForm accommodationId={accommodationId} id={id} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
